<template>
  <v-chip v-bind="$attrs" :style="chipStyle" >
    {{label}}
  </v-chip>
</template>

<script>
import colorMixin from "@/components/mixins/ColorMixin";

export default {
  name: "StatusChip",
  mixins: [colorMixin],
  props: {
    value: { type:String, default: 'not_started' } // 'not_started' | 'in_progress' | 'closed'
  },
  inheritAttrs: false,
  computed: {
    config() {
      return this.workshopStatusColors(this.value) || this.workshopStatusColors('not_started')
    },
    label() {
      return this.config.label
    },
    chipStyle() {
      return {
        backgroundColor: this.config.backgroundHex,
        color: this.config.colorHex
      }
    }
  },
}
</script>


<style scoped>

</style>